<template>
  <v-card elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Periodo a imputar</h6>
      <p v-if="!isViewModal" class="text-body-2">Ingrese la fecha de emisión de la factura y la fecha de vencimiento del cobro</p>
      <v-row class="mt-0">
        <v-col md="3">
          <DatePickerEsp
            :initToday="true"
            label="Fecha"
            :date="invoice.cbte_fch"
            :isRequired="true"
            name="cbte_fch"
            :isViewModal="isViewModal"
            :disabled="periodoCerrado()"
            @setDate="
              (date) => {
                invoice.cbte_fch = date;
              }
            "
          />
          <span v-if="periodoCerrado()" class="red--text caption">El período contable de este comprobante ya está cerrado.</span>
        </v-col>
        <v-col md="3" v-if="(concepto_selected != null && concepto_selected.Id != 1) || concepto_selected == null"
          ><!--PRODUCTO CONCEPTO-->
          <DatePickerEsp            
            :initToday="true"
            label="Periodo desde (Min: -10 días de fecha de emisión)"
            :date="invoice.cbte_fch_serv_desde"
            :isRequired="true"
            name="cbte_fch_serv_desde"
            :isViewModal="isViewModal"
            @setDate="
              (date) => {
                invoice.cbte_fch_serv_desde = date;
              }
            "
          />
        </v-col>
        <v-col md="3" v-if="(concepto_selected != null && concepto_selected.Id != 1) || concepto_selected == null">
          <DatePickerEsp            
            :initToday="true"
            label="Periodo hasta (Max: +10 días de fecha de emisión)"
            :date="invoice.cbte_fch_serv_hasta"
            :isRequired="true"
            name="cbte_fch_serv_hasta"
            :isViewModal="isViewModal"
            @setDate="
              (date) => {
                invoice.cbte_fch_serv_hasta = date;
              }
            "
          />
        </v-col>
        <v-col md="3">
          <DatePickerEsp            
            :initToday="true"
            label="Fecha Vto. Pago"
            :date="invoice.fch_vto_pago"
            :isRequired="true"
            name="fch_vto_pago"
            :isViewModal="isViewModal"
            @setDate="
              (date) => {
                invoice.fch_vto_pago = date;
              }
            "
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import DatePickerEsp from "@/components/DatePickerEsp.vue";
import { contabilidadService } from "@/libs/ws/contabilidadService";
export default {
  created() {
    this.$validator = this.validator;
  },
  components: { DatePickerEsp },
  props: {
    invoice: Object,
    validator: Object,
    isViewModal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    concepto_selected: null,
    fecha_bloqueo: null, // Último día con período contable cerrado del receptor (null = nada bloqueado)
    fecha_bloqueo_receiver_id: null, // Evita repetir la consulta si el receptor no cambió
  }),
  watch: {
    invoice: {
      handler: function (newValue) {
        if ((this.concepto_selected == null && newValue.concepto != null) || (newValue.concepto != null && this.concepto_selected.Id != newValue.concepto.Id)) {
          this.concepto_selected = newValue.concepto;
        }

        if (newValue.receiver != null && newValue.receiver.id > 0 && newValue.receiver.id != this.fecha_bloqueo_receiver_id) {
          this.loadFechaBloqueo(newValue.receiver.id);
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.invoice.receiver != null && this.invoice.receiver.id > 0) {
      this.loadFechaBloqueo(this.invoice.receiver.id);
    }
  },
  methods: {
    // El comprobante tiene fecha en un período contable ya cerrado del receptor: la
    // fecha tampoco se puede editar (regenerar el asiento pisaría un período mayorizado).
    periodoCerrado() {
      return this.invoice.id > 0 && this.fecha_bloqueo != null && this.invoice.cbte_fch != null && this.invoice.cbte_fch <= this.fecha_bloqueo;
    },
    loadFechaBloqueo(emitter_id) {
      this.fecha_bloqueo_receiver_id = emitter_id;
      contabilidadService
        .estado({ emitter_id })
        .then((r) => {
          this.fecha_bloqueo = r.result.fecha_bloqueo;
        })
        .catch(() => {});
    },
  },
};
</script>
